import React from 'react';
import { Box, Grid } from '@mui/material';
import OrderWidget from '../widgets/OrderWidget';
import { reverse } from 'lodash';
import CustomCard2 from '../cards/CustomCard2';

const DashSidebar = ({ orders }) => {
    return (
        <>
            <Box>
                <CustomCard2 title={'Latest orders'} height={300}>
                    <Grid container padding={1}>
                        {reverse(
                            orders?.map((order, index) => (
                                <Grid item sm={12} key={index}>
                                    <OrderWidget
                                        order_id={order.id}
                                        order_number={order.order_number}
                                        order_status={order.order_status}
                                        total_amount={order.total_amount}
                                        delivery_type={order.delivery_type}
                                        created_at={order.created_at}
                                        key={index}
                                    />
                                </Grid>
                            )),
                        )}
                    </Grid>
                </CustomCard2>
            </Box>
        </>
    );
};

export default DashSidebar;
